import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'referrals',
    viewPath: props.viewPath,
  })
  let referrals = useDataValue({
    context: 'referrals',
    viewPath: props.viewPath,
  })
  let referral_index = useDataValue({
    context: 'referral_item',
    path: 'index',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(referrals.filter((_, index) => index !== referral_index))
  }
}
